import { isResellerPoint } from '@/utils/hopPuntos';

const isEnabled = (value) => value === true || value === 1 || value === '1';

const getCapabilities = (point) => {
  const hasSeller = isResellerPoint(point);

  return [
    { label: 'Entrega envíos', enabled: isEnabled(point.allow_deliveries) },
    { label: 'Acepta envíos', enabled: isEnabled(point.allow_drop_off) },
    { label: 'Vende envíos', enabled: hasSeller }
  ].filter((capability) => capability.enabled);
};

const ServiceBadges = ({ point, className = '' }) => {
  const capabilities = getCapabilities(point);

  if (capabilities.length === 0) return null;

  return (
    <div
      role="group"
      className={`flex flex-wrap gap-6 ${className}`}
      aria-label="Servicios disponibles"
    >
      {capabilities.map(({ label }) => (
        <span
          key={label}
          title={label}
          aria-label={label}
          className="inline-flex items-center rounded-full bg-cyan-light px-8 py-5 text-10 font-semibold text-cyan-dark"
        >
          {label}
        </span>
      ))}
    </div>
  );
};

export default ServiceBadges;